/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import { Message } from "primereact/message"
import { Dropdown } from "primereact/dropdown"
import CustomToolBar from "../../../ToolBar/customToolbar"
import {
  confirmation,
  confirmationRefused,
  extentTypes,
} from "../../../types/dropDownTypes"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  prevForm,
  nextForm,
} from "../../../utils/utils"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import { UserContext } from "../../../../../context/userContext"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"

const ProgramQuestions = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    administrativeInterview,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [programQuestions, setProgramQuestions] = useState(
    interview[INTERVIEW_SECTIONS.PROGRAM]
  )
  const [mixedQuestions, setMixedQuestions] = useState([])
  const [validationErrors, setValidationErrors] = useState({})

  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) =>
            q.section === INTERVIEW_SECTIONS.PROGRAM &&
            !q.field.endsWith("section")
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.PROGRAM
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.PROGRAM, programQuestions)
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_PROGRAM_QUESTIONS_DATA, {
          GpraH1: programQuestions?.gpra_h_1,
          GpraH2A1: programQuestions?.gpra_h_2a1,
          GpraH2A2: programQuestions?.gpra_h_2a2,
          GpraH2B1: programQuestions?.gpra_h_2b1,
          GpraH2B2: programQuestions?.gpra_h_2b2,
          GpraH2C1: programQuestions?.gpra_h_2c1,
          GpraH2C2: programQuestions?.gpra_h_2c2,
          GpraH2D1: programQuestions?.gpra_h_2d1,
          GpraH2D2: programQuestions?.gpra_h_2d2,
          GpraH3: programQuestions?.gpra_h_3,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraHId: programQuestions?.gpra_h_id,
          Additional: getAdditionalQuestions(programQuestions),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              updateInterviewValues(INTERVIEW_SECTIONS.PROGRAM, {
                ...programQuestions,
                gpra_h_id: response.data.gpraHId,
              })
              handleLoadNext(false)
              setNextForm(
                nextForm(sections, activeIndex, administrativeInterview)
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ program: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (!disabledForm()) {
      if (
        programQuestions?.gpra_h_1 === undefined &&
        showQuestion(questions, "gpra_h_1")
      ) {
        errors.gpra_h_1 = errorMessages.requiredMessage
      }
      if (programQuestions?.gpra_h_1 && showQuestion(questions, "gpra_h_1")) {
        if (
          !programQuestions?.gpra_h_2a1 &&
          showQuestion(questions, "gpra_h_2")
        ) {
          errors.gpra_h_2a1 = errorMessages.requiredMessage
        } else if (
          programQuestions?.gpra_h_2a1 === "Yes" &&
          showQuestion(questions, "gpra_h_2")
        ) {
          if (
            !programQuestions?.gpra_h_2a2 &&
            showQuestion(questions, "gpra_h_2")
          ) {
            errors.gpra_h_2a2 = errorMessages.requiredMessage
          }
        }
        if (
          !programQuestions?.gpra_h_2b1 &&
          showQuestion(questions, "gpra_h_2")
        ) {
          errors.gpra_h_2b1 = errorMessages.requiredMessage
        } else if (
          programQuestions?.gpra_h_2b1 === "Yes" &&
          showQuestion(questions, "gpra_h_2")
        ) {
          if (
            !programQuestions?.gpra_h_2b2 &&
            showQuestion(questions, "gpra_h_2")
          ) {
            errors.gpra_h_2b2 = errorMessages.requiredMessage
          }
        }
        if (
          !programQuestions?.gpra_h_2c1 &&
          showQuestion(questions, "gpra_h_2")
        ) {
          errors.gpra_h_2c1 = errorMessages.requiredMessage
        } else if (
          programQuestions?.gpra_h_2c1 === "Yes" &&
          showQuestion(questions, "gpra_h_2")
        ) {
          if (
            !programQuestions?.gpra_h_2c2 &&
            showQuestion(questions, "gpra_h_2")
          ) {
            errors.gpra_h_2c2 = errorMessages.requiredMessage
          }
        }
        if (
          !programQuestions?.gpra_h_2d1 &&
          showQuestion(questions, "gpra_h_2")
        ) {
          errors.gpra_h_2d1 = errorMessages.requiredMessage
        } else if (
          programQuestions?.gpra_h_2d1 === "Yes" &&
          showQuestion(questions, "gpra_h_2")
        ) {
          if (
            !programQuestions?.gpra_h_2d2 &&
            showQuestion(questions, "gpra_h_2")
          ) {
            errors.gpra_h_2d2 = errorMessages.requiredMessage
          }
        }
        if (
          !programQuestions?.gpra_h_3 &&
          showQuestion(questions, "gpra_h_3")
        ) {
          errors.gpra_h_3 = errorMessages.requiredMessage
        }
      }
    }
    setValidationErrors(
      validateQuestions(
        programQuestions,
        INTERVIEW_SECTIONS.PROGRAM,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const disabledForm = () => {
    return interview.selectedInterview === "Intake"
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_h_1") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Is peer support available at this program?`}
            required
          />
          <Dropdown
            disabled={disabled}
            showClear={programQuestions?.pra_h_1 !== undefined}
            className={
              validationErrors.gpra_h_1
                ? gpraStyles.input2Error
                : gpraStyles.input2
            }
            value={programQuestions?.gpra_h_1}
            onChange={(e) => {
              updateState(
                "gpra_h_1",
                e.value,
                null,
                null,
                programQuestions,
                setProgramQuestions,
                [
                  { key: "gpra_h_2a1", value: "" },
                  { key: "gpra_h_2a2", value: "" },
                  { key: "gpra_h_2b1", value: "" },
                  { key: "gpra_h_2b2", value: "" },
                  { key: "gpra_h_2c1", value: "" },
                  { key: "gpra_h_2c2", value: "" },
                  { key: "gpra_h_2d1", value: "" },
                  { key: "gpra_h_2d2", value: "" },
                  { key: "gpra_h_3", value: "" },
                ]
              )
              removeError("gpra_h_1")
              removeError("gpra_h_2a1")
              removeError("gpra_h_2a2")
              removeError("gpra_h_2a2")
              removeError("gpra_h_2b1")
              removeError("gpra_h_2b2")
              removeError("gpra_h_2c1")
              removeError("gpra_h_2c2")
              removeError("gpra_h_2d1")
              removeError("gpra_h_2d2")
              removeError("gpra_h_3")
            }}
            options={confirmation}
            optionLabel="label"
            optionValue="value"
          />
          <FormError error={validationErrors.gpra_h_1} />
        </div>
      )
    }
    if (question.field === "gpra_h_2") {
      if (programQuestions?.gpra_h_1) {
        return (
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}.Have you achieved any of the following since you began receiving peer services from ${userCtx.session.user.organization_name}? If yes, do you believe that the services you received from ${userCtx.session.user.organization_name} helped you with this achievement?`}
            />
            <table className={gpraStyles.programTable}>
              <thead>
                <tr>
                  <td></td>
                  <td className={gpraStyles.columnHeader1}>Achieved?</td>
                  <td className={gpraStyles.columnHeader2}></td>
                  <td className={gpraStyles.columnHeader3}>
                    If yes, do you believe that the services you received from
                    Foundation for Recovery Inc. helped you with this
                    achievement?
                  </td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className={gpraStyles.column1}>
                    <label>a. Enrolled in school <span className={gpraStyles.required}> *</span></label>
                  </td>
                  <td>
                    <Dropdown
                      disabled={
                        disabledForm() ||
                        disabled ||
                        !programQuestions?.gpra_h_1
                      }
                      placeholder={disabledForm() ? "Not Applicable" : ""}
                      value={programQuestions?.gpra_h_2a1}
                      onChange={(e) => {
                        updateState(
                          "gpra_h_2a1",
                          e.value,
                          null,
                          null,
                          programQuestions,
                          setProgramQuestions,
                          null
                        )
                        removeError("gpra_h_2a1")
                      }}
                      options={confirmationRefused}
                      optionLabel="label"
                      optionValue="value"
                      className={
                        validationErrors.gpra_h_2a1 && gpraStyles.invalid
                      }
                      showClear={programQuestions?.gpra_h_2a1}
                    />
                  </td>
                  <td></td>
                  <td>
                    <Dropdown
                      disabled={
                        disabledForm() ||
                        programQuestions?.gpra_h_2a1 !== "Yes" ||
                        disabled
                      }
                      placeholder={disabledForm() ? "Not Applicable" : ""}
                      value={programQuestions?.gpra_h_2a2}
                      onChange={(e) => {
                        updateState(
                          "gpra_h_2a2",
                          e.value,
                          null,
                          null,
                          programQuestions,
                          setProgramQuestions,
                          null
                        )
                        removeError("gpra_h_2a2")
                      }}
                      options={confirmationRefused}
                      optionLabel="label"
                      optionValue="value"
                      className={
                        validationErrors.gpra_h_2a2 && gpraStyles.invalid
                      }
                      showClear={programQuestions?.gpra_h_2a2}
                    />
                  </td>
                  <td className={gpraStyles.tableError}>
                    <div className={gpraStyles.ml1}>
                      {validationErrors.gpra_h_2a1 && (
                        <Message
                          severity="error"
                          text={validationErrors.gpra_h_2a1}
                        />
                      )}
                      {validationErrors.gpra_h_2a2 && (
                        <Message
                          severity="error"
                          text={validationErrors.gpra_h_2a2}
                        />
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>b. Enrolled in vocational training <span className={gpraStyles.required}> *</span></label>
                  </td>
                  <td>
                    <Dropdown
                      disabled={
                        disabledForm() ||
                        disabled ||
                        !programQuestions?.gpra_h_1
                      }
                      placeholder={disabledForm() ? "Not Applicable" : ""}
                      value={programQuestions?.gpra_h_2b1}
                      onChange={(e) => {
                        updateState(
                          "gpra_h_2b1",
                          e.value,
                          null,
                          null,
                          programQuestions,
                          setProgramQuestions,
                          null
                        )
                        removeError("gpra_h_2b1")
                      }}
                      options={confirmationRefused}
                      optionLabel="label"
                      optionValue="value"
                      className={
                        validationErrors.gpra_h_2b1 && gpraStyles.invalid
                      }
                      showClear={programQuestions?.gpra_h_2b1}
                    />
                  </td>
                  <td></td>
                  <td>
                    <Dropdown
                      disabled={
                        disabledForm() ||
                        programQuestions?.gpra_h_2b1 !== "Yes" ||
                        disabled
                      }
                      placeholder={disabledForm() ? "Not Applicable" : ""}
                      value={programQuestions?.gpra_h_2b2}
                      onChange={(e) => {
                        updateState(
                          "gpra_h_2b2",
                          e.value,
                          null,
                          null,
                          programQuestions,
                          setProgramQuestions,
                          null
                        )
                        removeError("gpra_h_2b2")
                      }}
                      options={confirmationRefused}
                      optionLabel="label"
                      optionValue="value"
                      className={
                        validationErrors.gpra_h_2b2 && gpraStyles.invalid
                      }
                      showClear={programQuestions?.gpra_h_2b2}
                    />
                  </td>
                  <td className={gpraStyles.tableError}>
                    <div className={gpraStyles.ml1}>
                      {validationErrors.gpra_h_2b1 && (
                        <Message
                          severity="error"
                          text={validationErrors.gpra_h_2b1}
                        />
                      )}
                      {validationErrors.gpra_h_2b2 && (
                        <Message
                          severity="error"
                          text={validationErrors.gpra_h_2b2}
                        />
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>c. Currently employed <span className={gpraStyles.required}> *</span></label>
                  </td>
                  <td>
                    <Dropdown
                      disabled={
                        disabledForm() ||
                        disabled ||
                        !programQuestions?.gpra_h_1
                      }
                      placeholder={disabledForm() ? "Not Applicable" : ""}
                      value={programQuestions?.gpra_h_2c1}
                      onChange={(e) => {
                        updateState(
                          "gpra_h_2c1",
                          e.value,
                          null,
                          null,
                          programQuestions,
                          setProgramQuestions,
                          null
                        )
                        removeError("gpra_h_2c1")
                      }}
                      options={confirmationRefused}
                      optionLabel="label"
                      optionValue="value"
                      className={
                        validationErrors.gpra_h_2c1 && gpraStyles.invalid
                      }
                      showClear={programQuestions?.gpra_h_2c1}
                    />
                  </td>
                  <td></td>
                  <td>
                    <Dropdown
                      disabled={
                        disabledForm() ||
                        programQuestions?.gpra_h_2c1 !== "Yes" ||
                        disabled
                      }
                      placeholder={disabledForm() ? "Not Applicable" : ""}
                      value={programQuestions?.gpra_h_2c2}
                      onChange={(e) => {
                        updateState(
                          "gpra_h_2c2",
                          e.value,
                          null,
                          null,
                          programQuestions,
                          setProgramQuestions,
                          null
                        )
                        removeError("gpra_h_2c2")
                      }}
                      options={confirmationRefused}
                      optionLabel="label"
                      optionValue="value"
                      className={
                        validationErrors.gpra_h_2c2 && gpraStyles.invalid
                      }
                      showClear={programQuestions?.gpra_h_2c2}
                    />
                  </td>
                  <td className={gpraStyles.tableError}>
                    <div className={gpraStyles.ml1}>
                      {validationErrors.gpra_h_2c1 && (
                        <Message
                          severity="error"
                          text={validationErrors.gpra_h_2c1}
                        />
                      )}
                      {validationErrors.gpra_h_2c2 && (
                        <Message
                          severity="error"
                          text={validationErrors.gpra_h_2c2}
                        />
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>d. Living in stable housing <span className={gpraStyles.required}> *</span></label>
                  </td>
                  <td>
                    <Dropdown
                      disabled={
                        disabledForm() ||
                        disabled ||
                        !programQuestions?.gpra_h_1
                      }
                      placeholder={disabledForm() ? "Not Applicable" : ""}
                      value={programQuestions?.gpra_h_2d1}
                      onChange={(e) => {
                        updateState(
                          "gpra_h_2d1",
                          e.value,
                          null,
                          null,
                          programQuestions,
                          setProgramQuestions,
                          null
                        )
                        removeError("gpra_h_2d1")
                      }}
                      options={confirmationRefused}
                      optionLabel="label"
                      optionValue="value"
                      className={
                        validationErrors.gpra_h_2d1 && gpraStyles.invalid
                      }
                      showClear={programQuestions?.gpra_h_2d1}
                    />
                  </td>
                  <td></td>
                  <td>
                    <Dropdown
                      disabled={
                        disabledForm() ||
                        programQuestions?.gpra_h_2d1 !== "Yes" ||
                        disabled
                      }
                      placeholder={disabledForm() ? "Not Applicable" : ""}
                      value={programQuestions?.gpra_h_2d2}
                      onChange={(e) => {
                        updateState(
                          "gpra_h_2d2",
                          e.value,
                          null,
                          null,
                          programQuestions,
                          setProgramQuestions,
                          null
                        )
                        removeError("gpra_h_2d2")
                      }}
                      options={confirmationRefused}
                      optionLabel="label"
                      optionValue="value"
                      className={
                        validationErrors.gpra_h_2d2 && gpraStyles.invalid
                      }
                      showClear={programQuestions?.gpra_h_2d2}
                    />
                  </td>
                  <td className={gpraStyles.tableError}>
                    <div className={gpraStyles.ml1}>
                      {validationErrors.gpra_h_2d1 && (
                        <Message
                          severity="error"
                          text={validationErrors.gpra_h_2d1}
                        />
                      )}
                      {validationErrors.gpra_h_2d2 && (
                        <Message
                          severity="error"
                          text={validationErrors.gpra_h_2d2}
                        />
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )
      }
    }
    if (question.field === "gpra_h_3") {
      if (programQuestions?.gpra_h_1) {
        return (
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. To what extent has this program improved your quality of life?`}
              required
            />
            <Dropdown
              disabled={
                disabledForm() || disabled || !programQuestions?.gpra_h_1
              }
              placeholder={disabledForm() ? "Not Applicable" : ""}
              value={programQuestions?.gpra_h_3}
              onChange={(e) => {
                updateState(
                  "gpra_h_3",
                  e.value,
                  null,
                  null,
                  programQuestions,
                  setProgramQuestions,
                  null
                )
                removeError("gpra_h_3")
              }}
              options={extentTypes}
              optionLabel="label"
              optionValue="value"
              className={
                validationErrors.gpra_h_3
                  ? gpraStyles.input5Error
                  : gpraStyles.input5
              }
              showClear={programQuestions?.gpra_h_3}
            />
            <FormError error={validationErrors.gpra_h_3} />
          </div>
        )
      }
    }
  }
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              saveData={saveData}
              nextForm={true}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="H. PROGRAM-SPECIFIC QUESTIONS"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={programQuestions}
                    setEntity={setProgramQuestions}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.PROGRAM}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, programQuestions)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={programQuestions}
                      setEntity={setProgramQuestions}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.PROGRAM}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
    </div>
  )
}

ProgramQuestions.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

ProgramQuestions.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default ProgramQuestions
